export default {"src":"/komodo/_next/static/media/Telegram_Icon.f9971ad9.svg","height":75,"width":79,"blurWidth":0,"blurHeight":0};